import { Button, styled as muiStyled } from '@mui/material'

export const PrescriptionFooterContainer = muiStyled('div')(({ theme, items }) => ({
  position: 'sticky',
  width: '100%',
  height: '85px',
  bottom: '0px',
  padding: '0px 87px 0px 0px',
  display: 'grid',
  gridTemplateColumns: `repeat(${items}, 1fr)`,
  background: 'white',
  zIndex: 1000,
  boxShadow:
    'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
  '@media print': {
    display: 'none',
  },
}))

export const PrescriptionFooterButton = muiStyled(Button)(
  ({ theme }) => `
    font-size: 0.635rem;

    @media(min-width: 992px){
    font-size: 0.875rem;
    }
`,
)

export const PrescriptionFooterCustomizedButton = muiStyled(Button)(
  ({ theme, selected }) => `
    font-size: 0.635rem;
    // background: ${selected ? '#6779e3' : 'white'};
    color: ${selected ? '#fff' : '#000'};
    &:hover {
      background: ${selected ? '#3d4eaf' : '#f4f5f9'};
      color: ${selected ? '#fff' : '#000'};
    }

    @media(min-width: 992px){
    font-size: 0.875rem;
    }
`,
)
